// extracted by mini-css-extract-plugin
module.exports = {"nav":"ProductItemMenu_nav__23TUB","navItem":"ProductItemMenu_navItem__3Mncr","button":"ProductItemMenu_button__2R7R4","active":"ProductItemMenu_active__2JtKG"};